import React from 'react'
import styled from 'styled-components'
import { readableColor } from 'polished'
import { func } from 'prop-types'

import { useNavContext } from '../../contexts/NavContext'
import { Hamburger } from '../../icons'
import { Button } from '../Button'

const StyledHamburgerWrapper = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${({ theme }) => `(min-width: ${theme.breakpoints[1]})`} {
    display: none;
  }

  color: ${({ theme }) => readableColor(theme.backgroundAccent)};

  svg {
    height: 24px;
    width: 24px;
    g {
      stroke: ${({ theme }) => readableColor(theme.backgroundAccent)};
    }
  }
`

const StyledHamburger = styled(Hamburger)`
  path {
    stroke: ${({ theme }) => {
      if (theme?.colors?.black?.core) {
        return theme.isDark ? theme.colors.blue[300] : theme.colors.blue.core
      }
      return theme.textColor
    }};
  }
`

export const MenuButton = ({ onKeyDown }) => {
  const { toggleMenu } = useNavContext()
  return (
    <StyledHamburgerWrapper onClick={toggleMenu} onKeyDown={onKeyDown}>
      <StyledHamburger />
    </StyledHamburgerWrapper>
  )
}

MenuButton.propTypes = {
  onKeyDown: func,
}
